import React from "react";
import GridItem from "../../../../Components//UiComponents/GridItem/GridItem";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SopsInstanceForm from "./SopsInstance/SopsInstanceForm";
import SopsInstanceTable from "./SopsInstance/SopsInstanceTable";
import { useTranslation } from "react-i18next";

const SopsInstance = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 6,
      id: 2,
      //haveNoBg: true,
      component: <SopsInstanceForm />,
    },

    {
      x: 0,
      y: 7,
      width: 12,
      height: 6,
      id: 3,
      component: <SopsInstanceTable />,
    },
  ];

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <ArrowLeft
            size={18}
            color="#fff"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            {t("SOP Instance")}
          </div>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <div className="grid-stack grid-stack-instance-1 ">
            <GridItem layoutData={layoutData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SopsInstance;
